import { render, staticRenderFns } from "./ClientHead.vue?vue&type=template&id=0a28f0e3&scoped=true"
import script from "./ClientHead.vue?vue&type=script&lang=js"
export * from "./ClientHead.vue?vue&type=script&lang=js"
import style0 from "./ClientHead.vue?vue&type=style&index=0&id=0a28f0e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a28f0e3",
  null
  
)

export default component.exports